(function () {
  'use strict';

  // Mobilní menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('site-nav');
  if (toggle && nav) {
    var setOpen = function (open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    toggle.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  // Produkt: změna ceny podle zvolené varianty
  var form = document.getElementById('product-form');
  if (form) {
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add]');
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'id' || t.type !== 'radio') return;
      if (priceEl && t.dataset.price) priceEl.textContent = t.dataset.price;
      if (compareEl) {
        compareEl.textContent = t.dataset.compare || '';
        compareEl.hidden = !t.dataset.compare;
      }
      if (addBtn) addBtn.disabled = t.dataset.available !== 'true';

      // Přepnutí hlavní fotky podle varianty
      var idx = parseInt(t.dataset.image, 10);
      var items = document.querySelectorAll('.pg-item');
      if (!isNaN(idx) && items[idx] && !items[idx].classList.contains('is-active')) {
        Array.prototype.forEach.call(items, function (it) { it.classList.remove('is-active'); });
        var el = items[idx];
        el.classList.add('is-active');
        if (el.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          el.animate(
            [{ opacity: 0, transform: 'scale(.95)' }, { opacity: 1, transform: 'none' }],
            { duration: 450, easing: 'cubic-bezier(.2,.8,.2,1)' }
          );
        }
        if (el.getBoundingClientRect().top < 0) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
})();

// Animace: odhalení při scrollu + 3D náklon karet
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = document.documentElement.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);
  if (reduce || designMode) return;

  var sel = '.section-head, .section-title, .page-head, .product-card, .feature, .tile, .faq-item, .story-copy, .story-media, .cta h2, .cta .btn, .footer-grid > *';

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    document.querySelectorAll(sel).forEach(function (el) {
      var sibs = Array.prototype.filter.call(el.parentNode.children, function (c) { return c.matches(sel); });
      el.style.setProperty('--rd', Math.min(sibs.indexOf(el), 6) * 90 + 'ms');
      el.setAttribute('data-reveal', '');
      io.observe(el);
    });
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var active = null;
    var reset = function (el) { if (el) el.style.transform = ''; };
    document.addEventListener('pointermove', function (e) {
      var m = e.target.closest ? e.target.closest('.product-card-media') : null;
      if (active && active !== m) { reset(active); active = null; }
      if (!m) return;
      active = m;
      var r = m.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      m.style.transform = 'perspective(900px) rotateY(' + (px * 10).toFixed(2) + 'deg) rotateX(' + (-py * 10).toFixed(2) + 'deg) scale(1.02)';
    });
    document.addEventListener('pointerleave', function () { reset(active); active = null; }, true);
  }
})();

// Produktová stránka: zoom fotky podle polohy kurzoru
(function () {
  'use strict';
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.addEventListener('pointermove', function (e) {
    var item = e.target.closest ? e.target.closest('.pg-item') : null;
    if (!item) return;
    var r = item.getBoundingClientRect();
    item.style.setProperty('--ox', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
    item.style.setProperty('--oy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
  });
})();

// Produktová stránka: přepínač velikosti balení (sáček se zvětší, ovoce vyskočí, váha se přepočítá)
(function () {
  'use strict';
  var form = document.getElementById('product-form');
  var stage = document.querySelector('[data-pack-stage]');
  if (!form || !stage) return;
  var radios = Array.prototype.slice.call(form.querySelectorAll('input[type="radio"][name="id"]'));
  if (!radios.length) return;

  var big = stage.querySelector('[data-pack-big]');
  var fx = stage.querySelector('[data-pack-fx]');
  var float = stage.querySelector('.pack-float');
  var wEl = stage.querySelector('[data-pack-weight]');
  var perEl = stage.querySelector('[data-pack-per]');
  var priceEl = document.querySelector('[data-price]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var weights = radios.map(function (r) { return parseFloat(r.getAttribute('data-weight')) || 0; });
  var hasW = weights.every(function (w) { return w > 0; });
  var min = Math.min.apply(null, weights);
  var max = Math.max.apply(null, weights);

  function scaleOf(i) {
    if (hasW && max > min) return 0.8 + 0.5 * (weights[i] - min) / (max - min);
    if (radios.length > 1) return 0.85 + 0.45 * i / (radios.length - 1);
    return 1;
  }
  function labelOf(r) {
    var el = r.parentNode.querySelector('.pill-label');
    return el ? el.textContent : '';
  }
  function parseLabel(t) {
    var m = /^\s*(\d+(?:[.,]\d+)?)(.*)$/.exec(t);
    return m ? { n: parseFloat(m[1].replace(',', '.')), unit: m[2] } : null;
  }

  // Ikony na kartách mají výšku podle váhy; „výhodnější“ štítek dostane nejlevnější cena za 100 g
  radios.forEach(function (r, i) { r.parentNode.style.setProperty('--ps', scaleOf(i).toFixed(2)); });
  var pers = radios.map(function (r) { return parseFloat(r.getAttribute('data-per-raw')) || 0; });
  if (pers.every(function (p) { return p > 0; }) && pers.length > 1) {
    var best = pers.indexOf(Math.min.apply(null, pers));
    var unique = pers.filter(function (p) { return p === pers[best]; }).length === 1;
    if (unique) radios[best].parentNode.classList.add('pill--best');
  }

  // číslo a jednotka zvlášť: velké číslo, menší „g“ / „Gramů“ na jednom řádku
  wEl.innerHTML = '<span class="pack-num"></span><span class="pack-unit"></span>';
  var numEl = wEl.firstChild;
  var unitEl = wEl.lastChild;
  var shown = null;
  var raf = 0;
  function showWeight(label, animate) {
    var p = parseLabel(label);
    if (!p) { numEl.textContent = label; unitEl.textContent = ''; shown = null; return; }
    unitEl.textContent = p.unit.trim();
    if (!animate || reduce || shown === null) { numEl.textContent = Math.round(p.n); shown = p.n; return; }
    var from = shown, to = p.n, t0 = null;
    cancelAnimationFrame(raf);
    (function step(ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min((ts - t0) / 650, 1);
      var e = 1 - Math.pow(1 - k, 3);
      numEl.textContent = Math.round(from + (to - from) * e);
      if (k < 1) raf = requestAnimationFrame(step); else shown = to;
    })(performance.now());
  }

  function burst(s) {
    if (reduce || !fx || !fx.animate) return;
    var sr = stage.getBoundingClientRect();
    var fr = float.getBoundingClientRect();
    var cx = fr.left - sr.left + fr.width / 2;
    var cy = fr.top - sr.top + fr.height * 0.55;
    var count = Math.round(8 + s * 10);
    for (var k = 0; k < count; k++) {
      var bit = document.createElement('i');
      bit.className = 'pack-bit';
      bit.style.left = cx + 'px';
      bit.style.top = cy + 'px';
      var a = Math.random() * Math.PI * 2;
      var d = 50 + Math.random() * 90 * s;
      var dx = Math.cos(a) * d;
      var dy = Math.sin(a) * d - 40;
      var sc = 0.6 + Math.random() * 0.9;
      var anim = bit.animate([
        { transform: 'translate(0,0) scale(.3) rotate(0)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ') rotate(' + (Math.random() * 360) + 'deg)', opacity: 1, offset: 0.65 },
        { transform: 'translate(' + dx * 1.1 + 'px,' + (dy + 40) + 'px) scale(' + sc * 0.8 + ')', opacity: 0 }
      ], { duration: 750 + Math.random() * 450, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(bit);
      fx.appendChild(bit);
    }
  }

  function apply(i, animate) {
    var r = radios[i];
    var s = scaleOf(i);
    stage.style.setProperty('--s', s.toFixed(3));
    showWeight(labelOf(r), animate);
    var per = r.getAttribute('data-per');
    perEl.textContent = per || '';
    if (!animate) return;
    burst(s);
    if (float.animate && !reduce) {
      float.animate(
        [{ transform: 'rotate(-5deg)' }, { transform: 'rotate(3deg)', offset: 0.5 }, { transform: 'none' }],
        { duration: 700, easing: 'cubic-bezier(.3,1.6,.5,1)' }
      );
    }
    if (priceEl) {
      priceEl.classList.remove('is-tick');
      void priceEl.offsetWidth;
      priceEl.classList.add('is-tick');
    }
  }

  // Na telefonu posuň stránku tak, aby byl sáček i karty velikostí vidět najednou
  var mobile = window.matchMedia('(max-width: 899px)');
  function keepInView() {
    if (!mobile.matches) return;
    var sr = stage.getBoundingClientRect();
    var fr = stage.parentNode.getBoundingClientRect();
    var top = 84;
    var dy = 0;
    if (sr.top < top) dy = sr.top - top - 8;
    else if (fr.bottom > window.innerHeight - 8) dy = Math.min(fr.bottom - window.innerHeight + 16, sr.top - top - 8);
    if (Math.abs(dy) > 4) window.scrollBy({ top: dy, behavior: reduce ? 'auto' : 'smooth' });
  }

  form.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'id' || t.type !== 'radio') return;
    var i = radios.indexOf(t);
    if (i > -1) { apply(i, true); keepInView(); }
  });

  var start = radios.findIndex ? radios.findIndex(function (r) { return r.checked; }) : 0;
  apply(start > -1 ? start : 0, false);
})();
